type TFunction = (key: string) => string;

export const getPerformanceLabFaqData = (t: TFunction) => [
  {
    title: t('faq.q1.title'),
    description: <div>{t('faq.q1.body')}</div>,
  },
  {
    title: t('faq.q2.title'),
    description: <div>{t('faq.q2.body')}</div>,
  },
  {
    title: t('faq.q3.title'),
    description: <div>{t('faq.q3.body')}</div>,
  },
  {
    title: t('faq.q4.title'),
    description: (
      <div>
        {t('faq.q4.intro')}
        <ul>
          <li>
            <b>{t('faq.q4.basicLabel')}</b> — {t('faq.q4.basicBody')}
          </li>
          <li>
            <b>{t('faq.q4.proLabel')}</b> — {t('faq.q4.proBody')}
          </li>
          <li>
            <b>{t('faq.q4.eliteLabel')}</b> — {t('faq.q4.eliteBody')}
          </li>
        </ul>
        {t('faq.q4.outro')}
      </div>
    ),
  },
  {
    title: t('faq.q5.title'),
    description: <div>{t('faq.q5.body')}</div>,
  },
];
